export class StatusCodeFilters {
    'startsWith';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "startsWith",
            "baseName": "StartsWith",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StatusCodeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
